<div class="result-row-list">
  <result-one-row
    *ngFor="let resultItem of result; let i = index"
    [content]="test(resultItem)"
    [iconId]="resultItem.iconId"
    [mode]="i % 2 ? true : false"
  ></result-one-row>
</div>
